// extracted by mini-css-extract-plugin
export default {"Container":"CakePortionsCounter_Container__kudSa","CalculateModeCheckboxContainer":"CakePortionsCounter_CalculateModeCheckboxContainer__GvyrV"};